/**
 * @file: 跨卧柜
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../../cubeTree';
import * as UIToolkit from '../../UIToolkit';
import FrontCubeData from '../../frontCubeData';
import Utils from '../../utils/util';
import Move from '../move';
import { updateCubeList } from '../../update/updateCubeList';
import { doneAsync } from '../../update/done';
import { updateCodiSystem } from '../../update/updateCodiSystem';
import { getColWidth } from './getColWidth';
import { getEmptyWidth, getOverflowWidth } from './overflow';
import { findColsInTargetWidth } from './findColsInTargetWidth';
import { makeFillMoveTask } from './makeFillMoveTask';
import { makeOverflowMoveTask } from './makeOverflowMoveTask';
import { findOverFlowCols } from './findOverFlowCols';

function open(): void {
    let freezers: CubeId[] = CubeTree.findFreezer();

    recursionTrans(freezers);
    updateAllCabinets();
}

// 递归布局
function recursionTrans(freezers: CubeId[]): void {
    if (!freezers.length) {
        return;
    }
    let curFreezer: CubeId = freezers.shift();
    let prevFreezer: CubeId|null = CubeTree.findPrevFreezer(curFreezer);
    let prevOverflowWidth: PhysicsMeasurement = getOverflowWidth(prevFreezer);
    let curCabinet: CubeId = CubeTree.findFreezersCabinet(curFreezer);

    // 先排一次
    UIToolkit.cabinetsLayout([curCabinet], prevOverflowWidth);

    let emptyWidth: PhysicsMeasurement = getEmptyWidth(curFreezer);

    if (emptyWidth > 0) {
        // 前移
        fill(emptyWidth, freezers, curFreezer);

        // 再排一次
        UIToolkit.cabinetsLayout([curCabinet], prevOverflowWidth);
    }

    if (emptyWidth < 0) {
        // 后移
        let hasMoveTask: boolean = overflow(curFreezer);

        // 再排一次
        hasMoveTask && UIToolkit.cabinetsLayout([curCabinet], prevOverflowWidth);
    }

    recursionTrans(freezers);
}

function fill(emptyWidth: PhysicsMeasurement, freezers: CubeId[], curFreezer: CubeId): void {
    let cols: CubeId[][] = findColsInTargetWidth(freezers, emptyWidth);
    let moveTask: MoveTask = makeFillMoveTask(cols, curFreezer);

    Move.logic(moveTask.logic);
    Move.physics(moveTask.physics);
}

function overflow(curFreezer: CubeId): boolean {
    let nextFreezer: CubeId|null = CubeTree.findNextFreezer(curFreezer);

    if (!nextFreezer) {
        return false;
    }

    let cols: CubeId[][] = findOverFlowCols(curFreezer);
    let moveTask: MoveTask = makeOverflowMoveTask(cols, nextFreezer);

    Move.logic(moveTask.logic);
    Move.physics(moveTask.physics);

    return !!moveTask.logic.length;
}

function updateAllCabinets(): void {
    let allCubes: CubeId[] = CubeTree.findAllInFreezerCubes();

    updateCubeList(allCubes);
    updateCodiSystem();
    doneAsync();
}

export {
    open
};
